import React, { FC } from 'react';

interface Props {
    type?: string;
    name?: string;
    forId?: string;
    value?: string;
    checked?: boolean;
    children?: React.ReactNode;
    required?: boolean;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
}
/**
 *
 * @param type type (checkbox or radio)
 * @param forId input id
 * @param name name
 * @param value value
 * @param checked 체크 여부
 * @param children 뷰 텍스트
 * @param required 필수 입력값 여부
 * @returns InputChk
 */
export const InputChk: FC<Props> = (props) => {
    const {
        type,
        forId,
        value,
        name,
        checked,
        onChange,
        children,
        required = false,
        disabled = false,
    } = props;

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (onChange) onChange(event);
    };

    return (
        <>
            <input
                id={forId}
                type={type}
                name={name}
                value={value}
                onChange={handleInputChange}
                required={required}
                checked={checked ?? false}
                disabled={disabled}
            />
            <label className="input-chk" htmlFor={forId}>
                {children}
            </label>
        </>
    );
};
